// @flow

import { setUiSetting } from '../actions';
import { SHOW_CONFIG_VALIDATION_ERRORS } from './constants';

export const showValidationErrors = () => setUiSetting(SHOW_CONFIG_VALIDATION_ERRORS, true);

export const hideValidationErrors = () => setUiSetting(SHOW_CONFIG_VALIDATION_ERRORS, false);
